// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Awards/style.css
 ** module id = 603
 ** module chunks = 0
 **/